import { type AllCoverablesOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { atom } from 'recoil';
import { coverablesOnsaSelector } from '../selectors/coverablesOnsaSelector';

export const allCoverablesOnsaAtom = atom<AllCoverablesOnsaDTO>({
    key: 'allCoverablesOnsa',
    default: coverablesOnsaSelector
});
